import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "tph_save_flights_aa",
    stages: {
        logged_in_users_fd: 1,
        logged_in_users_fd_ddot: 4,
        logged_in_users_fd_mdot: 5,
        logged_in_users_fd_from_tph: 7
    },
    goals: {},
    defaultStage: 1
});
export function trackLoggedInUsersFD() {
    utils.stages.logged_in_users_fd();
}
export function trackLoggedInUsersFDdDot() {
    utils.stages.logged_in_users_fd_ddot();
}
export function trackLoggedInUsersFDmDot() {
    utils.stages.logged_in_users_fd_mdot();
}
export function trackLoggedInUsersFDFromTPH() {
    utils.stages.logged_in_users_fd_from_tph();
}
